import { useEffect } from 'react';

interface SocialMediaMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
}

export const SocialMediaMeta: React.FC<SocialMediaMetaProps> = ({
  title = 'DojoTrack | Martial Arts Studio Management System',
  description = 'Streamline your martial arts studio with DojoTrack. Manage students, classes, payments, and more with our comprehensive studio management platform.',
  image = '/social-media-share-dojotrack.png',
  url = window.location.href,
  type = 'website'
}) => {
  useEffect(() => {
    // Function to update or create meta tags
    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Update page title
    document.title = title;

    // Update Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);

    // Update Twitter Card tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    updateMetaTag('twitter:url', url);

    // Update standard meta description
    updateMetaTag('description', description, false);

  }, [title, description, image, url, type]);

  return null; // This component doesn't render anything
};

export default SocialMediaMeta;
